import styled from 'styled-components';

const ErrorMessage = styled.span`
  color: ${props => props.theme.errorMessage.fontColor};
`;

export default ErrorMessage;
